import * as types from './mutation-types'

const mutations = {
    setUpdateClassDialog (state, status) {
        state.updateClassDialog = status
    },
    setAddClassDialog (state, status) {
        state.addClassDialog = status
    },
    setUpdateClassList (state) {
        state.updateClassList = !state.updateClassList
    }
};

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js